import { useDisclosure } from '@chakra-ui/react';
import Router from 'next/router';

export function useModalRoute(isOpen?: boolean) {
  const modal = useDisclosure({
    isOpen,
    onClose: () => {
      Router.push({
        pathname: `/${Router.query.username || `reppl/${Router.query.rid}`}`,
      });
    },
  });

  return modal;
}
